import React, { useState } from 'react';

import { withTheme } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { DatePicker, DateTimePicker } from '@material-ui/pickers';
import { FilterCalendarDayIcon } from '../../icons';

const DatePickerDropdown = props => {
    const {
        date,
        setDate,
        theme,
        enableTimePicker,
        inputFormat = 'dddd, MMMM Do, YYYY',
        calendarIcon = true,
        ...pickerprops
    } = props;
    const [open, setOpen] = useState(false);
    const PickerComponent = enableTimePicker ? DateTimePicker : DatePicker;
    const viewsToShow = enableTimePicker ? ['date', 'hours', 'minutes'] : ['date'];
    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <div className="datepicker">
                <div className="dropdown">
                    <PickerComponent
                        open={open}
                        value={date}
                        views={viewsToShow}
                        onChange={setDate}
                        onClose={() => setOpen(false)}
                        inputFormat={inputFormat}
                        renderInput={inputprops => {
                            return (
                                <>
                                    <div className="datepicker">
                                        <div className="dropdown">
                                            <input
                                                className="date-text"
                                                {...inputprops.inputProps}
                                                ref={inputprops.inputRef}
                                                onClick={() => setOpen(!open)}
                                                style={{
                                                    ...(inputprops?.inputProps?.style || {}),
                                                    border: 0
                                                }}
                                                onChange={e => e.preventDefault()}
                                            />
                                            {calendarIcon && (
                                                <FilterCalendarDayIcon
                                                    style={{ color: theme.palette.primary.main }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </>
                            );
                        }}
                        {...pickerprops}
                    />
                </div>
            </div>
        </ClickAwayListener>
    );
};

export default withTheme(DatePickerDropdown);
